module.exports = __webpack_public_path__ + "static/media/AW0081-54L.cd7079ea.png";